function e(n, o, p) {
  const t = n.prerender;
  n.prerender = function(...i) {
    p.value.apply(this, i), t.apply(this, i);
  };
}
function y(n, o, p) {
  const t = n.postrender;
  n.postrender = function(...i) {
    p.value.apply(this, i), t.apply(this, i);
  };
}
function r(n, o, p) {
  const t = n.destroy;
  n.destroy = function(...i) {
    p.value.apply(this, i), t.apply(this, i);
  };
}
const a = (n) => (o) => {
  o.mixins && Array.isArray(o.mixins) && (o.mixins = [...o.mixins, n]);
};
export {
  e as a,
  r as d,
  a as m,
  y as p
};
